var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.badge)?_c('v-chip',{attrs:{"color":_vm.item.badge.color,"outlined":_vm.item.badge.outlined,"dark":_vm.isDark,"x-small":_vm.small}},[(_vm.item.badge.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.item.badge.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.item.badge.name)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }